import { newGuid } from "./guid";
import { Guid } from "client_legacy/ndaw/guid";

export type SizeInformation = {
	width: number;
	height: number;
};

type ResizeCallbackItem = {
	callback: ResizeCallback;
	id: Guid;
};

// We use a single instance as apparently it is better for performance,
// to still be able to use it as individual callbacks, we have a weak map
// to map the global handler to the individual handlers.
export type ResizeCallback = (size: SizeInformation) => void;
const _watcherMap = new WeakMap<Element, ResizeCallbackItem[]>();
const _resizeObserver = new ResizeObserver(
	(entries) => {
		for (const entry of entries) {
			const element: Element = entry.target;
			const callbackItems: ResizeCallbackItem[] | undefined = _watcherMap.get(element);
			callbackItems?.forEach(
				(item) => {
					const { width, height } = entry.contentRect;
					item.callback({ width, height });
				}
			);
		}
	}
);

export function registerSizeListener(
	element: Element,
	callback: ResizeCallback
): () => void {
	const existingCallback: ResizeCallbackItem[] | undefined = _watcherMap.get(element);
	const callbackId: Guid = newGuid();
	let newResizeCallbackCollectionItems: ResizeCallbackItem[] = [
		{
			id: callbackId,
			callback
		}
	];

	if (existingCallback) {
		// We unobserve the element to initiate the call when observing again
		_resizeObserver.unobserve(element);
		newResizeCallbackCollectionItems = [...existingCallback, ...newResizeCallbackCollectionItems];
	}

	_watcherMap.set(element, newResizeCallbackCollectionItems);
	_resizeObserver.observe(element);

	return () => unregisterSizeListener(element, callbackId);
}

function unregisterSizeListener(element: Element, id: Guid): void {
	const callbackItems: ResizeCallbackItem[] | undefined = _watcherMap.get(element)
		?.filter(x => x.id !== id);
	if (callbackItems && callbackItems.length > 0) {
		_watcherMap.set(element, callbackItems);
	} else {
		_watcherMap.delete(element);
		_resizeObserver.unobserve(element);
	}
}
